export const homeObjOne = {
  id: "about",
  headline: "About me",
  imgStart: false,
  alt: "photo of me",
};
